import React, { ComponentType, ReactNode } from 'react';
import compose from 'lodash/fp/compose';
import { withRouter } from 'react-router';
import { withConfig } from '@catalogo/core-connect/config';
import { withCookies } from '@catalogo/core-connect/cookies';
import withPaymentV2 from '@catalogo/service-americanas-product/src/hocs/payment-v2';
import { inCashOptions, getMainCashbackText, getPaymentInstallmentText } from '../helpers/payment-v2-float-cta';

type Result = {
  seller: {
    id: string;
  };
};

interface WithPaymentV2FloatCtaProps {
  children: ReactNode;
  enableAme: boolean;
  currentSku: {
    offers: {
      result: Result[];
    };
  };
  mainPayment: {
    type: string;
    cashback: {
      cashbacks: string;
    };
  };
  buyTogetherPriceText: string;
  history: string;
  cookies: {
    listId: string;
  };
  config: {
    sellerId: string;
  };
}

export const withPaymentV2FloatCta = (Component: ComponentType) => (props: WithPaymentV2FloatCtaProps) => {
  const { enableAme, currentSku, mainPayment, buyTogetherPriceText, history, cookies, config } = props;
  const { type } = mainPayment;
  const offer = currentSku?.offers?.result?.[0];
  const isB2WSeller = offer?.seller?.id === config.sellerId;
  const isWeddingList = !!(cookies?.listId ?? '') && isB2WSeller;
  const hasSecondaryButton = enableAme || isWeddingList;

  const showCashbackText = !buyTogetherPriceText && !inCashOptions.includes(type);
  const cashbackText = showCashbackText && getMainCashbackText(mainPayment?.cashback?.cashbacks);
  const paymentInstallmentText = getPaymentInstallmentText(mainPayment, !!cashbackText);

  const paymentOptionV2Props = {
    history,
    offer,
    isWeddingList,
    hasSecondaryButton,
    cashbackText,
    paymentInstallmentText,
  };

  return <Component {...props} {...paymentOptionV2Props} />;
};

export default compose(withRouter, withConfig, withCookies, withPaymentV2, withPaymentV2FloatCta);
